<template>
  <Drawer :closable="false"
          class-name="layout__menu"
          @on-close="handleCloseMenu"
          :width="drawerWidth"
          :value="menuVisible">
    <div class="flex flex--align-center flex--justify-between" slot="header">
      <v-icon type="iconclear-24px" right-text="菜单" @click.native="handleCloseMenu"></v-icon>
      <v-icon type="iconexit_to_app-24px" v-if="token" right-text="账户登出" @click.native="handleLogout"></v-icon>
      <v-icon v-else type="iconaccount_circle-24px" right-text="用户登录" @click.native="handleLogin"></v-icon>
    </div>
    <Menu :active-name="activeName"
          :open-names="openNames"
          class="v-menu"
          @on-select="handleSelectMenu"
          width="448px"
          >
      <!-- 控制面板 -->
      <template v-if="token">
        <Submenu :name="dashboard.name"
                  :key="dashboard.name"
                  style="margin-bottom: 12px; margin-top: -2px">
          <template slot="title">
            <v-icon :type="dashboard.meta.icon" size="20"></v-icon>
            <span>{{dashboard.meta.title}}</span>
          </template>
          <template v-for="child in dashboard.children">
            <MenuItem :name="child.name"
                      :to="child.defaultPath || child.path"
                      :target="onDashboard ? '_self' : '_blank'"
                      v-if="isShowPermissionMenu(child)"
                      :key="child.name">{{child.meta.title}}</MenuItem>
          </template>
        </Submenu>
        <div class="layout__menu-line"/>
      </template>
      <!-- static pages -->
      <template v-for="item in routerList">
        <Submenu :name="item.name"
                  :key="item.name"
                  v-if="item.children && item.children.length">
          <template slot="title">
            <v-icon :type="item.meta.icon" size="20"></v-icon>
            <span>{{item.meta.title}}</span>
          </template>
          <template v-for="child in item.children">
            <MenuItem :name="child.name"
                      :to="child.defaultPath || child.path"
                      v-if="isShowPermissionMenu(child)"
                      :key="child.name">{{child.meta.title}}</MenuItem>
          </template>
        </Submenu>
        <MenuItem :name="item.name"
                  :to="item.defaultPath || item.path"
                  :target="onDashboard ? '_blank' : '_self'"
                  v-else
                  :key="item.name">
          <v-icon :type="item.meta.icon" size="20"></v-icon>
          <span>{{item.meta.title}}</span>
        </MenuItem>
      </template>
      <template v-if="token">
        <div class="layout__menu-line"/>
        <MenuItem name="user"
                  to="/user"
                  key="user"
                  :target="onDashboard ? '_self' : '_blank'"
          >
          <v-icon type="iconperson-24px" size="20"></v-icon>
          <span>我的账户</span>
        </MenuItem>
      </template>
    </Menu>
    <div class="about-us">
      <v-icon type="iconlogoflat"></v-icon>
      <a href="http://www.voxelcloud.net.cn/" target="_blank">了解更多关于体素科技</a>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import mainRouterList from '@/router/mainRouterList';
import { clearState } from "@/utils/loginStatePersist.js";

export default {
  name: 'layoutMenu',
  computed: {
    ...mapState(['menuVisible', 'token']),
    ...mapState('user', ['menuList']),
    dashboard() {
      return mainRouterList[0].children.find(item => item.name === 'dashboard');
    },
    routerList() {
      return mainRouterList[0].children.filter(item => item.meta.menu);
    },
    activeName() {
      const nameArr = this.$route.name.split('-');
      return nameArr.slice(0, 2).join('-');
    },
    openNames() {
      return [this.$route.name.split('-')[0]];
    },
    onDashboard() {
      return this.$route.name.split('-')[0] === 'dashboard';
    },
    drawerWidth() {
      return window.innerWidth > 768 ? 448 : 67;
    }
  },
  methods: {
    ...mapMutations(['updateState', 'clearSession']),
    handleCloseMenu() {
      this.updateState({
        menuVisible: false,
      });
    },
    handleSelectMenu(name) {
      const parentName = this.$route.name.split('-')[0];
      if (parentName !== name) {
        this.handleCloseMenu();
      }
    },
    handleLogin() {
      this.updateState({
        menuVisible: false,
      });
      window.open('/login', '_blank');
      // this.$router.push({
      //   name: 'login'
      // });
    },
    handleLogout() {
      clearState();
      this.updateState({
        menuVisible: false,
      });
      this.$router.replace({
        name: 'login',
      });
      this.$Message.success('操作成功');
    },
    isShowPermissionMenu(item) {
      const { meta } = item;
      const { permission } = meta;
      if (permission) {
        return this.menuList.includes(permission);
      }
      return true;
    },
  },
};
</script>
